var exports = {
  "Vf": "MessageReactions.module__reactionsGrid___V0czRU",
  "RW": "MessageReactions.module__reactionContainer___V0czRU",
  "sU": "MessageReactions.module__reactionButton___V0czRU",
  "I1": "MessageReactions.module__reactionMe___V0czRU",
  "iX": "MessageReactions.module__reactionInner___V0czRU",
  "Zg": "MessageReactions.module__emoji___V0czRU",
  "Ps": "MessageReactions.module__countWrapper___V0czRU",
  "lG": "MessageReactions.module__reactionContainerDisabled___V0czRU",
  "II": "MessageReactions.module__reactionButtonDisabled___V0czRU",
  "Go": "MessageReactions.module__reactionPickerButton___V0czRU",
  "SD": "MessageReactions.module__reactionPickerButtonActive___V0czRU",
};

module.exports = exports;
